import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const getSessionId = () => {
  const existing = sessionStorage.getItem('lcs-visitor-session');
  if (existing) return existing;

  const value = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  sessionStorage.setItem('lcs-visitor-session', value);
  return value;
};

const VisitorTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const controller = new AbortController();
    const timer = window.setTimeout(() => {
      fetch('/api/visitor-events', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          page: location.pathname,
          referrer: document.referrer,
          sessionId: getSessionId(),
        }),
        keepalive: true,
        signal: controller.signal,
      }).catch(() => {});
    }, 500);

    return () => {
      window.clearTimeout(timer);
      controller.abort();
    };
  }, [location.pathname]);

  return null;
};

export default VisitorTracker;
